export {
    TypoTitle,
    TypoHeader,
    TypoText,
    TypoTextBold,
    TypoTextSmall,
} from "./Typo";
